<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div :class="`modal-container border-success col-md-${col}`">
          <div class="modal-header content-header">
            <strong>{{data.title}}</strong>
          </div>
          <div class="modal-body content-body">
            <slot/>
          </div>
          <div class="modal-footer content-footer">
            <slot name="footer">
              <button class="btn btn-outline-danger" @click="$emit('close')">
                Close
              </button>
              <button class="btn btn-outline-success" @click="$emit('submit')">
                Submit
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    col: {
      type: String,
      default: "12"
    }
  }
};
</script>
<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  margin: 0px auto;
  padding: 15px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.content-header {
  padding: 0 0 10px 0;
}

.modal-header {
  color: #42b983;
}

.modal-header strong {
  width: 100%;
  text-align: center;
}

.content-body {
  margin: 0;
  padding: 10px 0;
}

.content-footer {
  padding: 10px 0 0 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>